class CountdownBlock extends HTMLElement {
  connectedCallback() {
    this.dateTargetString = this.getAttribute('data-date-target');
    this.dateTarget = new Date(this.dateTargetString);

    this.endYear = parseInt(this.getAttribute('data-end-year'));
    this.endMonth = Math.max(parseInt(this.getAttribute('data-end-month')) - 1, 0) || 0;
    this.endDay = parseInt(this.getAttribute('data-end-day'));
    this.endHour = parseInt(this.getAttribute('data-end-hour')) || 0;
    this.endMinute = parseInt(this.getAttribute('data-end-minute')) || 0;

    if (
      !Number.isFinite(this.endYear) ||
      !Number.isFinite(this.endDay) ||
      !Number.isFinite(this.endMonth)
    ) {
      console.warn('Invalid date information for countdown-block');
      this.remove();
      return;
    }

    this.startDate = new Date();
    this.endDate = new Date(
      this.endYear,
      this.endMonth,
      this.endDay,
      this.endHour,
      this.endMinute,
      0
    );

    this.timerElements = ['days', 'hours', 'minutes', 'seconds'].reduce(
      (acc, unit) => ({
        ...acc,
        [unit]: this.querySelector(`[data-${unit}]`),
      }),
      {}
    );

    if (this.startDate > this.endDate) {
      this.remove();
    }

    this.startCountdown();
  }

  startCountdown() {
    this.classList.remove('opacity-0');
    this.classList.add('opacity-100');
    this.updateTimer();
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date();

    // Handle post-end date behavior
    const isPastEndDate = now > this.endDate;
    if (isPastEndDate && !this.isThemeEditor) {
      this.classList.add('hidden');
      return;
    }

    const timeLeft = this.endDate - now;

    const times = {
      days: Math.floor(timeLeft / (1000 * 60 * 60 * 24)),
      hours: Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((timeLeft % (1000 * 60)) / 1000),
    };

    Object.entries(times).forEach(([unit, value]) => {
      if (this.timerElements[unit]) {
        this.timerElements[unit].textContent = String(value).padStart(2, '0');
      }
    });
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('countdown-block', CountdownBlock);
